import { createSectionForm } from "./sectionFormKit";

// Customer: components/sections/OemSolutions/OemSolutions.js
const OemSolutions = createSectionForm({
  icon: "car-line",
  title: "OEM Solutions",
  fields: [
    { name: "title", label: "Title" },
    { name: "description", label: "Description", type: "richtext" },
    {
      name: "items",
      label: "Highlights",
      type: "list",
      itemLabel: "Highlight",
      fields: [
        { name: "image", label: "Icon", type: "media" },
        { name: "name", label: "Title" },
      ],
    },
  ],
});

export default OemSolutions;
